import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layouts/Header";
import SubscriptionInvoices from "../../pages/dynamic/SubscriptionInvoices";
import "../../assets/styles/local/MyPlan.css";
import eyeIcon from "../../assets/icons/eye.svg";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import SeeBuildingBlockPopup from "../dynamic/SeeBuildingBlockPopup";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  AddBillingInformation,
  UpdateBillingInformation,
  FetchBillingInformation,
  FetchIndustry,
  AddIndustryToCompany,
} from "../../redux/actions/action";

import {
  ADD_BILLING_INFORMATION,
  UPDATE_BILLING_INFORMATION,
  FETCH_INDUSTRY,
  ADD_INDUSTRY_TO_COMPANY,
} from "../../redux/constants/type";

const MyPlan = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const params = useParams();
  console.log("param", params.id);

  // const { param1, param2, projectname } = location.state;

  const [tabChange, setTabChange] = useState("CurrentPlan");

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const PlanNameFromLocal = window.localStorage.getItem("packageName");
  const CompanyNameFromLocal = window.localStorage.getItem("companyname");

  const addBillingInformationRes = useSelector(
    (state) => state.user.addBillingInformationRes,
  );
  const updateBillingInformationRes = useSelector(
    (state) => state.user.updateBillingInformationRes,
  );
  const fetchBillingInformationRes = useSelector(
    (state) => state.user.fetchBillingInformationRes,
  );
  const fetchIndustryRes = useSelector((state) => state.user.fetchIndustryRes);
  const addIndustryToCompanyRes = useSelector(
    (state) => state.user.addIndustryToCompanyRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("My-Plan").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [buildingPopupShow, setBuildingPopupShow] = useState(false);
  const [successfullyMSGShow, setSuccessfullyMSGShow] = useState(false);
  const [planName, setPlanName] = useState("");
  const [companyName, setCompanyName] = useState(CompanyNameFromLocal);
  const [address, setAddress] = useState("");
  const [addressParts, setAddressParts] = useState({
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [companyEmail, setCompanyEmail] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [vatNo, setVatNo] = useState("");
  const [noOfUsers, setNoOfUsers] = useState("");
  const [billingInformationID, setBillingInformationID] = useState("");
  const [businessIndustry, setBusinessIndustry] = useState("");
  const [selectedIndustryId, setSelectedIndustryId] = useState("");
  const [businessIndustryShow, setBusinessIndustryShow] = useState(false);
  const [businessIndustries, setBusinessIndustries] = useState([]);

  const industryRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (industryRef.current && !industryRef.current.contains(e.target)) {
        setBusinessIndustryShow(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Fetch industries on mount
  useEffect(() => {
    dispatch(FetchIndustry());
  }, []);

  // Populate businessIndustries from API response
  useEffect(() => {
    if (fetchIndustryRes?.status === true && fetchIndustryRes?.data) {
      setBusinessIndustries(fetchIndustryRes.data);
    }
  }, [fetchIndustryRes]);

  // Handle AddIndustryToCompany response
  useEffect(() => {
    if (addIndustryToCompanyRes?.status === true) {
      setSuccessfullyMSGShow(true);
      setTimeout(() => {
        setSuccessfullyMSGShow(false);
        dispatch({
          type: ADD_INDUSTRY_TO_COMPANY,
          data: {},
        });
      }, 4000);
    }
  }, [addIndustryToCompanyRes]);

  const [businessType, setBusinessType] = useState("");
  const [businessTypeShow, setBusinessTypeShow] = useState(false);
  const [businessTypes] = useState([
    { id: 1, label: "Product" },
    { id: 2, label: "Service" },
    { id: 3, label: "Both" },
  ]);
  const businessTypeRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (
        businessTypeRef.current &&
        !businessTypeRef.current.contains(e.target)
      ) {
        setBusinessTypeShow(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Handle Add Billing Api start.
  const handleAdd_Billing = () => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let trimText = companyName.trim();

    if (trimText === "") {
      // setProjectNameWarning(true);
    } else if (!re.test(contactEmail) && contactEmail) {
      // setEmailInvalid(true);
    } else {
      dispatch(
        AddBillingInformation(
          companyName,
          address,
          companyEmail,
          contactName,
          contactEmail,
          vatNo,
          addressParts,
        ),
      );
    }
    setTimeout(() => {
      dispatch({
        type: ADD_BILLING_INFORMATION,
        data: {},
      });
    }, 2000);
  };
  // Handle Add Billing Api end.

  // fetching Billing Api start.
  useEffect(() => {
    dispatch(
      FetchBillingInformation(localStorage.getItem("MyPlanBillingFetchid")),
    );
  }, [addBillingInformationRes, updateBillingInformationRes]);
  // fetching Billing Api end.

  // addBilling Responce start.
  useEffect(() => {
    if (addBillingInformationRes?.status === true) {
      setBillingInformationID(
        addBillingInformationRes?.data?.billingInformationid,
      );
      localStorage.setItem(
        "MyPlanBillingFetchid",
        addBillingInformationRes?.data?.billingInformationid,
      );
      setSuccessfullyMSGShow(true);
      setTimeout(() => {
        setSuccessfullyMSGShow(false);
      }, 4000);
    }
  }, [addBillingInformationRes]);
  // addBilling Responce end.

  // Binding while fetching start.
  useEffect(() => {
    if (fetchBillingInformationRes.status === true) {
      setPlanName(fetchBillingInformationRes?.data[0]);
      setCompanyName(fetchBillingInformationRes?.data[0]?.companyname);
      setAddress(fetchBillingInformationRes?.data[0]?.address);
      setAddressParts({
        street:
          fetchBillingInformationRes?.data[0]?.streetWithNumber ||
          fetchBillingInformationRes?.data[0]?.street ||
          "",
        city: fetchBillingInformationRes?.data[0]?.city || "",
        state: fetchBillingInformationRes?.data[0]?.state || "",
        pinCode:
          fetchBillingInformationRes?.data[0]?.pinCode ||
          fetchBillingInformationRes?.data[0]?.pincode ||
          fetchBillingInformationRes?.data[0]?.postalCode ||
          "",
        country: fetchBillingInformationRes?.data[0]?.country || "",
      });
      setCompanyEmail(fetchBillingInformationRes?.data[0]?.companyEmail);
      setContactName(fetchBillingInformationRes?.data[0]?.contactname);
      setContactEmail(fetchBillingInformationRes?.data[0]?.contactEmail);
      setVatNo(fetchBillingInformationRes?.data[0]?.vaTnumber);
      setNoOfUsers(fetchBillingInformationRes?.data[0]?.numbersOfUsers);
      setBillingInformationID(
        fetchBillingInformationRes?.data[0]?.billingInformationid,
      );
      setBusinessIndustry(
        fetchBillingInformationRes?.data[0]?.industryname || "",
      );
      setSelectedIndustryId(
        fetchBillingInformationRes?.data[0]?.industryid || "",
      );
      setBusinessType(fetchBillingInformationRes?.data[0]?.type || "");
    }
  }, [fetchBillingInformationRes]);
  // Binding while fetching end.

  // Handle Update Billing Api start.
  const handleUpdate_Billing = () => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let trimText = companyName.trim();

    if (trimText === "") {
      // setProjectNameWarning(true);
    } else if (!re.test(contactEmail) && contactEmail) {
      // setEmailInvalid(true);
    } else {
      dispatch(
        UpdateBillingInformation(
          billingInformationID,
          companyName,
          address,
          companyEmail,
          contactName,
          contactEmail,
          vatNo,
          addressParts,
        ),
      );
    }
    setTimeout(() => {
      dispatch({
        type: UPDATE_BILLING_INFORMATION,
        data: {},
      });
    }, 2000);
  };
  // Handle Update Billing Api end.

  // UpdateBilling Responce Start.
  useEffect(() => {
    if (updateBillingInformationRes.status === true) {
      localStorage.setItem(
        "MyPlanBillingFetchid",
        updateBillingInformationRes?.data?.billingInformationid,
      );
      setSuccessfullyMSGShow(true);
      setTimeout(() => {
        setSuccessfullyMSGShow(false);
      }, 4000);
    }
  }, [updateBillingInformationRes]);
  // UpdateBilling Responce end.

  // ASC address with postal code start
  const getAddressParts = (parsed = {}) => ({
    street: parsed.streetWithNumber || parsed.street || "",
    city: parsed.city || "",
    state: parsed.state || "",
    pinCode: parsed.pinCode || parsed.postalCode || "",
    country: parsed.country || "",
  });

  const handleAddressSelect = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);
      setAddress(parsed.formattedAddress); // Store full Google address.
      setAddressParts(getAddressParts(parsed));
      // setZipCode(postalCode); // Store only postal code.
      console.log("final address", parsed.formattedAddress);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end

  return (
    <section className="px-2">
      <div style={{ position: "relative" }}>
        <Header
          // setQuery={setQuerystring}
          leftComponent={
            <div className="d-flex align-items-baseline flex-wrap gap-4">
              <div
                className="settingText"
                onClick={() => {
                  history.push("/settings");
                }}
              >
                {/* Settings */}
                {t("Settings")}
              </div>
              <div
                className="pt-2 d-flex pe-3"
                style={{ background: "#FFFFFF" }}
              >
                <p className="pt-1 ps-4 myplanTxt">
                  {/* My Plan */}
                  {t("My Plan")}
                </p>
                {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
              </div>
            </div>
          }
        />

        {buildingPopupShow && (
          <SeeBuildingBlockPopup
            buildingPopupShow2={buildingPopupShow}
            setBuildingPopupShow2={setBuildingPopupShow}
          />
        )}
      </div>

      <div className="d-flex flex-nowrap gap-3 justify-content-end pt-2 pe-2">
        <button
          className="mb-0 ms-md-auto cancelBtn ascButton"
          // onClick={() => {
          //   if (typeInScreen !== "") {
          //     setCancelPopupShow(true);
          //   } else {
          //     history.goBack();
          //     // history.push("/InvoiceAllList");
          //   }
          // }}

          onClick={() => {
            history.goBack();
          }}
        >
          {/* Cancel */}
          {t("Cancel ")}
        </button>

        <button
          className="mb-0 makeInvoBtn ascButton"
          onClick={() => {
            if (billingInformationID) {
              handleUpdate_Billing();
            } else {
              handleAdd_Billing();
            }
            // Save selected industry to company
            if (selectedIndustryId) {
              dispatch(AddIndustryToCompany(businessType, selectedIndustryId));
            }
          }}
        >
          {/* Change */}
          {t("Change")}
        </button>
      </div>

      {successfullyMSGShow && (
        <p className="pt-2 pe-2 fw-bold text-end text-success animate__animated animate__slideInRight">
          {/* Information Updated Successfully */}
          {t("Information Updated Successfully")}
        </p>
      )}

      {/* current plan div start */}
      <div className="planDivHead pt-3 row">
        <div
          className={`col-6 col-lg-2 pt-4 text-center pointer ${
            tabChange === "CurrentPlan"
              ? "planDivHeadBox-highlighter"
              : "planDivHeadBox-non-highlighter"
          }`}
          onClick={() => setTabChange("CurrentPlan")}
        >
          <p>
            {/* Current <br /> Plan */}
            {t("Current")} <br /> {t("Plan")}
          </p>
          <hr
            className={
              tabChange === "CurrentPlan"
                ? "planHorizontalBarPro"
                : "planHorizontalBar"
            }
          />
        </div>
        {/* current plan div end */}

        {/* Subscription_Invoices div start */}
        <div
          className={`col-6 col-lg-2 pt-4 text-center pointer ${
            tabChange === "Subscription_Invoices"
              ? "planDivHeadBox-highlighter"
              : "planDivHeadBox-non-highlighter"
          }`}
          onClick={() => setTabChange("Subscription_Invoices")}
        >
          <p>
            {/* Subscription <br /> Invoices */}
            {t("Subscription")} <br /> {t("Plan")}
          </p>
          <hr
            className={
              tabChange === "Subscription_Invoices"
                ? "planHorizontalBarPro"
                : "planHorizontalBar"
            }
          />
        </div>
        {/* Subscription_Invoices div end */}

        <div // for smooth underline
          className="withUnderLineAnima-"
          style={{
            left:
              tabChange === "CurrentPlan"
                ? "14%"
                : tabChange === "Subscription_Invoices"
                  ? "24%"
                  : tabChange === "Subscription_Invoices-666"
                    ? "285px"
                    : "",
          }}
        ></div>
      </div>

      <div className="planUnderDiv row">
        {tabChange === "CurrentPlan" && (
          <div className="p-4 row">
            <div
              className="col-12 col-lg-7"
              // data-aos="fade-right"
              // data-aos-delay="500"
            >
              <p className="ps-2 mb-0 planTxt">
                {/* Plan */}
                {t("Plan")}
              </p>
              <div className="row">
                <div
                  className="asc-input-container col-9 col-md-6"
                  id="ascInput"
                >
                  <label
                    className="asc-label-top ClientNameText"
                    style={{ background: "#fff" }}
                  >
                    {t("Plan Name")}
                    {/* {FetchTranslationList[33]?.translation} */}
                  </label>
                  <input
                    type="text"
                    // disabled
                    readOnly
                    className="asc_NormalInput ps-4"
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#323232",
                      width: "100%",
                      background: "white",
                    }}
                    placeholder="Plan Name"
                    // value={planName}
                    value={
                      PlanNameFromLocal === "Building Block"
                        ? "Premium Package"
                        : PlanNameFromLocal
                    }
                    onChange={(e) => {
                      setPlanName(e.target.value);
                      // setTypeInScreen("asc");
                    }}
                  />
                </div>
                <div className="upgradeDiv col-4">
                  <a
                    href="https://spire.solutions/pricing/"
                    target="_blank"
                    className=""
                    style={{ textDecoration: "none", color: "unset" }}
                    rel="noreferrer"
                  >
                    <p>
                      {/* Upgrade  */}
                      {t("Upgrade")}
                    </p>
                  </a>
                </div>
              </div>

              {/* Business Industry Dropdown */}
              <div
                className="asc-input-container businessSelectContainer"
                id="ascInput"
                ref={industryRef}
                style={{ position: "relative" }}
              >
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  Business Industry
                </label>

                <input
                  type="text"
                  readOnly
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                    cursor: "pointer",
                  }}
                  placeholder="Select Business Industry"
                  value={businessIndustry}
                  onClick={() => setBusinessIndustryShow((prev) => !prev)}
                />

                {/* Chevron icon */}
                <span
                  onClick={() => setBusinessIndustryShow((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    transform: businessIndustryShow
                      ? "translateY(-50%) rotate(180deg)"
                      : "translateY(-50%) rotate(0deg)",
                    transition: "transform 0.2s",
                    cursor: "pointer",
                    fontSize: "11px",
                    color: "#888",
                    pointerEvents: "auto",
                  }}
                >
                  ▾
                </span>

                {/* Dropdown list */}
                {businessIndustryShow && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "calc(100% + 4px)",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      listStyle: "none",
                      padding: "4px",
                      margin: 0,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                      zIndex: 999,
                      maxHeight: "180px",
                      overflowY: "auto",
                    }}
                  >
                    {businessIndustries.length === 0 ? (
                      <li
                        style={{
                          padding: "10px 12px",
                          fontSize: "13px",
                          color: "#888",
                        }}
                      >
                        No data to display!
                      </li>
                    ) : (
                      businessIndustries.map((item) => (
                        <li
                          key={item.industryId}
                          onClick={() => {
                            setBusinessIndustry(item.industryName);
                            setSelectedIndustryId(item.industryId);
                            setBusinessIndustryShow(false);
                          }}
                          style={{
                            padding: "9px 12px",
                            fontSize: "13px",
                            cursor: "pointer",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background:
                              item.industryName === businessIndustry
                                ? "#F4F5F4"
                                : "transparent",
                          }}
                          onMouseEnter={(e) => {
                            if (item.industryName !== businessIndustry)
                              e.currentTarget.style.background = "#f9f9f9";
                          }}
                          onMouseLeave={(e) => {
                            if (item.industryName !== businessIndustry)
                              e.currentTarget.style.background = "transparent";
                          }}
                        >
                          {item.industryName}
                          {item.industryName === businessIndustry && (
                            <span
                              style={{ color: "#7F77DD", fontSize: "13px" }}
                            >
                              ✓
                            </span>
                          )}
                        </li>
                      ))
                    )}
                  </ul>
                )}
              </div>

              {/* Business Type Dropdown */}
              <div
                className="asc-input-container businessSelectContainer"
                id="ascInput"
                ref={businessTypeRef}
                style={{ position: "relative" }}
              >
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  Business Type
                </label>

                <input
                  type="text"
                  readOnly
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                    cursor: "pointer",
                  }}
                  placeholder="Select Business Type"
                  value={businessType}
                  onClick={() => setBusinessTypeShow((prev) => !prev)}
                />

                {/* Chevron icon */}
                <span
                  onClick={() => setBusinessTypeShow((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    transform: businessTypeShow
                      ? "translateY(-50%) rotate(180deg)"
                      : "translateY(-50%) rotate(0deg)",
                    transition: "transform 0.2s",
                    cursor: "pointer",
                    fontSize: "11px",
                    color: "#888",
                  }}
                >
                  ▾
                </span>

                {/* Dropdown list */}
                {businessTypeShow && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "calc(100% + 4px)",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      listStyle: "none",
                      padding: "4px",
                      margin: 0,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                      zIndex: 999,
                      maxHeight: "180px",
                      overflowY: "auto",
                    }}
                  >
                    {businessTypes.map((item) => (
                      <li
                        key={item.id}
                        onClick={() => {
                          setBusinessType(item.label);
                          setBusinessTypeShow(false);
                        }}
                        style={{
                          padding: "9px 12px",
                          fontSize: "13px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          background:
                            item.label === businessType
                              ? "#F4F5F4"
                              : "transparent",
                        }}
                        onMouseEnter={(e) => {
                          if (item.label !== businessType)
                            e.currentTarget.style.background = "#f9f9f9";
                        }}
                        onMouseLeave={(e) => {
                          if (item.label !== businessType)
                            e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {item.label}
                        {item.label === businessType && (
                          <span style={{ color: "#7F77DD", fontSize: "13px" }}>
                            ✓
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="pt-4 d-flex gap-3">
                <p className="mb-0 seebuildingBlock">
                  {/* See Building Blocks */}
                  {t("See Building Blocks ")}
                </p>
                <img
                  src={eyeIcon}
                  alt=""
                  className="pointer a-nimate__animated animate__backInDown animate__delay-1s"
                  onClick={() => {
                    setBuildingPopupShow(true);
                  }}
                />
              </div>
            </div>

            <div
              className="col-12 col-lg-5 pt-5 pt-lg-0"
              // data-aos="fade-left"
              // data-aos-duration="1000"
            >
              <p className="planTxt">
                {/* Billing Information */}
                {t("Billing Information ")}
              </p>
              <div className="asc-input-container" id="ascInput">
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  {/* Company Name */}
                  {t("Company Name")}
                </label>
                <input
                  type="text"
                  // disabled
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                  }}
                  placeholder="Company Name"
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                    // setTypeInScreen("asc");
                  }}
                />
              </div>

              <div className="asc-input-container" id="ascInput">
                <label className="asc-label-top projectNameText">
                  {/* Address */}
                  {t("Address")}
                </label>
                {/* <textarea
                 id="w3review"
                 name="w3review"
                 rows="4"
                 cols="50"
                 // placeholder="Notes"
                 className="PlanNotesInput ps-3 bordered-inputs"
                 style={{ width: "100%", resize: "none" }}
                 value={address}
                 onChange={(e) => {
                   setAddress(e.target.value);
                   // setTypeInScreen("asc");
                 }}
               ></textarea> */}

                <GooglePlacesAutocomplete
                  debounce={800}
                  renderInput={(props) => (
                    <textarea
                      className="PlanNotesInput ps-3 bordered-inputs"
                      style={{
                        // border: "none",
                        width: "100%",
                        height: "80px",
                        overflow: "hidden",
                        resize: "none",
                      }}
                      {...props}
                      onChange={(e) => {
                        props.onChange?.(e);
                        setAddressParts({
                          street: "",
                          city: "",
                          state: "",
                          pinCode: "",
                          country: "",
                        });
                      }}
                      rows={4}
                      placeholder="Address"
                    />
                  )}
                  onSelect={(e) => {
                    handleAddressSelect(e);
                    // setChangeComp("asc");
                  }}
                  placeholder="Address"
                  initialValue={address}
                  withSessionToken={true}
                />
              </div>

              <div className="asc-input-container" id="ascInput">
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  {/* Company Email */}
                  {t("Company Email")}
                </label>
                <input
                  type="email"
                  // disabled
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                  }}
                  placeholder="Company Email"
                  value={companyEmail}
                  onChange={(e) => {
                    setCompanyEmail(e.target.value);
                    // setTypeInScreen("asc");
                  }}
                />
              </div>

              <div className="asc-input-container" id="ascInput">
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  {/* Contact Name */}
                  {t("Contact Name")}
                </label>
                <input
                  type="text"
                  // disabled
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                  }}
                  placeholder="Contact Name"
                  value={contactName}
                  onChange={(e) => {
                    setContactName(e.target.value);
                    // setTypeInScreen("asc");
                  }}
                />
              </div>

              <div className="asc-input-container" id="ascInput">
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  {/* Contact Email */}
                  {t("Contact Email")}
                </label>
                <input
                  type="email"
                  // disabled
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                  }}
                  placeholder="Contact Email"
                  value={contactEmail}
                  onChange={(e) => {
                    setContactEmail(e.target.value);
                    // setTypeInScreen("asc");
                  }}
                />
              </div>

              <div className="row">
                <div
                  className="asc-input-container col-12 col-sm-6"
                  id="ascInput"
                >
                  <label
                    className="asc-label-top ClientNameText"
                    style={{ left: "25px", background: "#fff" }}
                  >
                    {/* Vat no. */}
                    {t("Vat  no.")}
                  </label>
                  <input
                    type="text"
                    // disabled
                    className="asc_NormalInput ps-4"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#323232",
                      width: "100%",
                      background: "white",
                    }}
                    placeholder="Vat no."
                    value={vatNo}
                    onChange={(e) => {
                      setVatNo(e.target.value);
                      // setTypeInScreen("asc");
                    }}
                  />
                </div>

                <div
                  className="asc-input-container col-12 col-sm-6"
                  id="ascInput"
                >
                  <label
                    className="asc-label-top ClientNameText"
                    style={{ left: "20px", background: "#fff" }}
                  >
                    {/* No Of Users */}
                    {t("No. of User ")}
                  </label>
                  <input
                    type="text"
                    // disabled
                    readOnly
                    className="asc_NormalInput ps-4"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#323232",
                      width: "100%",
                      background: "white",
                    }}
                    placeholder="No Of Users"
                    value={noOfUsers}
                    onChange={(e) => {
                      setNoOfUsers(e.target.value);
                      // setTypeInScreen("asc");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {tabChange === "Subscription_Invoices" && <SubscriptionInvoices />}
      </div>
    </section>
  );
};

export default MyPlan;
